<template>
    <vs-input 
        v-model="value" 
        :placeholder="placeholder"
        @input="onInput"
    />
</template>

<script>
import Vue from 'vue'
import { debounce } from 'lodash'

export default Vue.extend({
    data() {
        return {
            value: "",
            placeholder: "Buscar"
        }
    },
    created() {
        // Create debounced version of handleFilter
        this.debouncedFilter = debounce((val) => {
            this.params.handleFilter({
                [this.params.columnName]: val
            })
        }, 300) // 300ms delay
    },
    methods: {
        onInput(newVal) {
            this.debouncedFilter(newVal)
        }
    },
    mounted() {
        const values = this.params.getValues()
        if (values[this.params.columnName] !== null && values[this.params.columnName] !== undefined) {
            this.value = values[this.params.columnName]
        }

        this.placeholder = this.params.placeholder || "Buscar"
    },
    beforeDestroy() {
        // Cancel any pending debounced calls when component is destroyed
        this.debouncedFilter.cancel()
    }
})
</script>